import { createStore } from "redux";
import { reducerRoot } from "./reducer";

const store = createStore(reducerRoot)

export default store